module.exports = __webpack_public_path__ + "fonts/Etna-Sans-serif.otf";